import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../components/Loader';
//import { getUserData, loginUser } from '../Api';
import { getUserData, loginUser } from '../Api/customer';
import '../assets/css/login.css';


import { toast } from 'react-toastify';

export default function Login({ onLoginUser }) {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setloading] = useState(false);
    const navigate = useNavigate('');

    const slides = [
        {
            image: <img src={require('../images/guest_login.png')} alt="guest_login" />,
            text: "Save Big on Your Medicines",
            subtext: "Save up to 80% on WHO standard medicines"
        },
        {
            image: <img src={require('../images/login.png')} alt="login" />,
            text: "Know Your Medicines",
            subtext: "View medicine information like: Dosage, Side Effects and cheaper substitute products available."
        },
        {
            image: <img src={require('../images/signup.png')} alt="signup" />,
            text: "Get Expert Advice",
            subtext: "Login/signup to have Expert Advice,Health Tips and much more."
        }
    ];

    const [currentSlide, setCurrentSlide] = React.useState(0);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    React.useEffect(() => {
        const interval = setInterval(nextSlide, 3000);
        return () => clearInterval(interval);
    }, []);

    async function userLogin(e) {
        e.preventDefault();
        setloading(true);

        if (!username) {
            setloading(false);
            toast.warning("Please enter username!");
            return;
        }

        if (!password) {
            setloading(false);
            toast.warning("Please enter password!");
            return;
        }

        try {
            // ✅ LOGIN (ONLY ONCE)
            const response = await loginUser({ username, password });
            console.log(response);
            

            if (!response || !response.token) {
                toast.error("Please enter correct details!");
                setloading(false);
                return;
            }

            // ✅ Clear old data
            localStorage.removeItem("auth_token");
            localStorage.removeItem("user_data");

            // ✅ Save token
            localStorage.setItem("auth_token", response.token);

            // ✅ Fetch logged-in WP user
            const userData = await getUserData(response.token);
            console.log(userData);
            

            const loggedInUserData = {
                id: userData.id,
                name: userData.name,
                email: response.user_email,
                username: response.user_nicename,
                isSuperAdmin: userData.is_super_admin
            };

            localStorage.setItem("user_data", JSON.stringify(loggedInUserData));

            // ✅ Notify parent
            onLoginUser(response);

            // ✅ Redirect
            navigate(userData.is_super_admin ? '/dashboard' : '/');

            // ✅ Reset fields
            setUsername('');
            setPassword('');
            setloading(false);

        } catch (error) {
            console.error(error);
            setloading(false);
            toast.error("There is some problem!");
        }
    }

    return (
        <>
            {
                loading === true ? <Loader /> : (<>
                    <div className="content-wrapper">
                        <div className="wrapper signUp" style={{ width: "100%" }}>
                            <div className="small-container d-flex" style={{ justifyContent: "space-around" }}>
                                <div className="login-carousel">
                                    <div className="login-carousel-inner" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                                        {slides.map((slide, index) => (
                                            <div className="login-carousel-item" key={index}>
                                                {slide.image}
                                                <h2>{slide.text}</h2>
                                                <p>{slide.subtext}</p>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="login-dots">
                                        {slides.map((_, index) => (
                                            <span
                                                key={index}
                                                className={`login-dot ${index === currentSlide ? 'active' : ''}`}
                                                onClick={() => goToSlide(index)}
                                            ></span>
                                        ))}
                                    </div>
                                </div>
                                <hr style={{ height: "450px" }} />
                                <div className="form" onSubmit={userLogin}>
                                    <div className="heading">LOGIN</div>
                                    <form>
                                        <div>
                                            <label htmlFor="username">Username</label>
                                            <input type="username" id="email" placeholder="Enter your username" onChange={(e) => { setUsername(e.target.value) }} />
                                        </div>
                                        <div>
                                            <label htmlFor="password">Password</label>
                                            <input
                                                type="password"
                                                id="password"
                                                onChange={(e) => setPassword(e.target.value)}
                                                placeholder="Enter you password"
                                            />
                                        </div>
                                        <button type="submit">Submit</button>
                                        <h2 align="center" className="or">
                                            OR
                                        </h2>
                                    </form>
                                    <p>
                                        Don't have an account ? <Link to="/signup"> Register </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>)
            }
        </>
    );
}
